import { computed } from 'vue';
import { useFilters } from '@/Composables/useFilters.js';
import {
    buildDefaultPaymentsFilterParams,
    buildPaymentsCurrentFilter,
    buildPaymentsFilterList,
    buildPaymentsSortList,
    removeSearchSelectedFilter,
} from '@/Utils/Views/BackerCenterViewPaymentsUtility.js';
import { apiClient } from '@/Clients/ApiClient';
import UsersService from '@/Services/UsersService';
import Resources from '@/Resources.js';
import { backerPaymentsSortType } from '@/Models';
import { convertArrayParamsToCommaSeparatedList } from '@/Utils/FiltersUtility.js';

const usersService = new UsersService(apiClient);

export function useBackerCenterPaymentsFilters() {

    const baseFilters = useFilters({
        buildDefaultFilterParams: buildDefaultPaymentsFilterParams,
        buildCurrentFilter: buildPaymentsCurrentFilter,
        buildFilterList: buildPaymentsFilterList,
        buildSortList: buildPaymentsSortList,
        removeSelectedFilter: removeSearchSelectedFilter,
        storageKey: 'paymentsSearchParams',
        apiLoadMethod: async (params, loadMore) => {
            const formattedParams = convertArrayParamsToCommaSeparatedList(params);
            const { data } = await usersService.getBackerPayments(formattedParams);
            return {
                ...data.pagedPayments,
                searchResultQuery: data.searchResultQuery,
                params: data.params,
            };
        },
        resources: Resources.BackerCenter,
        sortEnum: backerPaymentsSortType,
    });

    const hasPayments = computed(() => baseFilters.hasItems.value);

    return {
        ...baseFilters,
        hasPayments,
    };
}